import {getArgsAsTypesafeObjectProperties} from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
  'GetDeviceContent',
  'SelectDevice',
  'SelectAllDevices',
  'GetUserDevices',
  'SetDeviceDates',
  'UpdateCalibrationFactor',
  'UpdateSpectralMeasurement',
  'UpdateLabMeasurement',
  'CalibrateDevice',
  'UpdateStationId',
  'UpdateSpectralMeasurementDate',
  'GetDevices',
  'DeleteUserDevice',
  'AddUserDevice',
  'UploadCsv',
);
